import React from 'react';
import ProductCardStaticPlaceholder from 'components/consumer/ProductCardStaticPlaceholder';

const ModularSofasCollectionPlaceholder = () => (
  <div className="max-[767px]:flex max-[767px]:min-h-[225px] max-[767px]:mt-2">
    <div className="grid grid-cols-[repeat(auto-fit,minmax(100%,1fr))] gap-[10px] md:m-2 md:grid-cols-[repeat(auto-fit,minmax(300px,calc(50%_-_5px)))] lg:grid-cols-[repeat(auto-fit,minmax(300px,calc(33%_-_7px)))] min-[1400px]:grid-cols-[repeat(auto-fit,minmax(300px,calc(25%_-_10px)))] max-[767px]:!flex max-[767px]:!flex-row max-[767px]:!flex-nowrap max-[767px]:!overflow-x-scroll">
      {[0, 1, 2, 3].map(i => (
        <div
          key={i}
          className="max-[767px]:!flex-shrink-0 max-[767px]:!mr-2 max-[767px]:!max-w-[500px] max-[767px]:!w-4/5"
        >
          <ProductCardStaticPlaceholder />
        </div>
      ))}
    </div>
  </div>
);

export default ModularSofasCollectionPlaceholder;
